import React from "react";
import "./ClarificationCard.css";

interface ClarificationCardProps {
  question: string;
  options: string[];
  onSelectOption: (option: string) => void;
}

const ClarificationCard: React.FC<ClarificationCardProps> = ({
  question,
  options,
  onSelectOption,
}) => {
  return (
    <div className="clarification-card">
      <div className="clarification-card__question">{question}</div>

      {options && options.length > 0 && (
        <div className="clarification-card__options">
          <div className="clarification-card__buttons">
            {options.map((option, index) => (
              <button
                key={index}
                className="clarification-card__btn"
                onClick={() => onSelectOption(option)}
                type="button"
              >
                {option}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ClarificationCard;
